const dot=document.getElementById('cursorDot');
const ring=document.getElementById('cursorRing');
if(dot&&ring){
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;dot.style.left=mx+'px';dot.style.top=my+'px'});
  (function animRing(){rx+=(mx-rx)*.12;ry+=(my-ry)*.12;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(animRing)})();
  document.querySelectorAll('a,button,.prob-card,.bun-card,.ing-card').forEach(el=>{
    el.addEventListener('mouseenter',()=>{ring.style.width='52px';ring.style.height='52px';ring.style.opacity='1'});
    el.addEventListener('mouseleave',()=>{ring.style.width='36px';ring.style.height='36px';ring.style.opacity='.5'});
  });
}

const mainNav=document.getElementById('mainNav');
if(mainNav){
  window.addEventListener('scroll',()=>{
    mainNav.classList.toggle('scrolled',window.scrollY>40);
  });
}

const pawContainer=document.getElementById('pawsContainer');
if(pawContainer){
  const pawEmojis=['🐾','🐾','🐾','🐾','🐕','🌿'];
  for(let i=0;i<18;i++){
    const p=document.createElement('div');
    p.className='floating-paw';
    p.textContent=pawEmojis[Math.floor(Math.random()*pawEmojis.length)];
    p.style.left=Math.random()*100+'%';
    p.style.animationDuration=(10+Math.random()*20)+'s';
    p.style.animationDelay=Math.random()*15+'s';
    p.style.fontSize=(14+Math.random()*16)+'px';
    pawContainer.appendChild(p);
  }
}

const track=document.getElementById('marquee');
if(track){
  const marqueeItems=[
    {icon:'⭐',text:'4.9/5 Rating'},{icon:'🐾',text:'8,400+ Dogs'},
    {icon:'📦',text:'Free US Shipping'},{icon:'🔬',text:'Vet Reviewed'},
    {icon:'🌿',text:'100% Natural'},{icon:'🛡️',text:'30-Day Guarantee'},
    {icon:'⭐',text:'4.9/5 Rating'},{icon:'🐾',text:'8,400+ Dogs'},
    {icon:'📦',text:'Free US Shipping'},{icon:'🔬',text:'Vet Reviewed'},
    {icon:'🌿',text:'100% Natural'},{icon:'🛡️',text:'30-Day Guarantee'},
  ];
  [...marqueeItems,...marqueeItems].forEach(item=>{
    track.innerHTML+=`<div class="marquee-item"><span>${item.icon}</span>${item.text}<span class="m-sep"></span></div>`;
  });
}

window.addEventListener('load',()=>{
  const badge=document.getElementById('heroBadge');
  const words=document.querySelectorAll('.hero h1 .word');
  const sub=document.getElementById('heroSub');
  const rating=document.getElementById('heroRating');
  const btns=document.getElementById('heroBtns');
  const img=document.getElementById('heroImg');
  if(badge)setTimeout(()=>{badge.style.cssText='opacity:1;transform:none;transition:opacity .5s,transform .5s cubic-bezier(.16,1,.3,1)'},100);
  words.forEach((w,i)=>setTimeout(()=>{w.style.cssText='opacity:1;transform:none;transition:opacity .5s,transform .5s cubic-bezier(.16,1,.3,1)'},200+i*80));
  if(sub)setTimeout(()=>{sub.style.cssText='opacity:1;transform:none;transition:opacity .6s,transform .6s cubic-bezier(.16,1,.3,1)'},750);
  if(rating)setTimeout(()=>{rating.style.cssText='opacity:1;transform:none;transition:opacity .6s,transform .6s cubic-bezier(.16,1,.3,1)'},900);
  if(btns)setTimeout(()=>{btns.style.cssText='opacity:1;transform:none;transition:opacity .6s,transform .6s cubic-bezier(.16,1,.3,1)'},1050);
  if(img)setTimeout(()=>{img.style.cssText='opacity:1;transition:opacity .8s ease'},800);
  const allChips=[document.getElementById('chip1'),document.getElementById('chip2'),document.getElementById('chip3'),document.getElementById('chip4'),document.getElementById('chip5')];
  allChips.forEach((c,i)=>setTimeout(()=>{if(c)c.style.cssText='opacity:1;transform:none;transition:opacity .6s,transform .6s cubic-bezier(.34,1.56,.64,1)'},1000+i*150));
});

const io=new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    if(!e.isIntersecting)return;
    if(e.target.classList.contains('reveal')||e.target.classList.contains('prob-card')||
       e.target.classList.contains('ing-card')||e.target.classList.contains('rev-card')||
       e.target.classList.contains('bun-card')||e.target.classList.contains('hiw-step')){
      e.target.classList.add('revealed');
    }
    if(e.target.classList.contains('stat-item')){
      const counter=e.target.querySelector('.counter');
      if(counter&&!counter.dataset.done){
        counter.dataset.done='1';
        const target=+counter.dataset.target;
        const dur=1800;const start=performance.now();
        const tick=now=>{
          const p=Math.min((now-start)/dur,1);
          const ease=1-Math.pow(1-p,4);
          counter.textContent=Math.round(ease*target).toLocaleString();
          if(p<1)requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }
    if(e.target.classList.contains('ing-card')){
      const bar=e.target.querySelector('.ing-bar');
      if(bar)setTimeout(()=>{bar.style.width=bar.dataset.width},100);
    }
    if(e.target.id==='hiwLineFill'){setTimeout(()=>{e.target.style.width='100%'},200)}
    if(e.target.id==='hiwResult'){setTimeout(()=>{e.target.style.cssText='opacity:1;transform:none;transition:opacity .7s ease,transform .7s cubic-bezier(.16,1,.3,1)'},400)}
    if(e.target.id==='guarInner'){e.target.style.cssText='opacity:1;transform:none;transition:opacity .8s ease,transform .8s cubic-bezier(.16,1,.3,1)'}
    io.unobserve(e.target);
  });
},{threshold:.15});

document.querySelectorAll('.reveal,.prob-card,.ing-card,.rev-card,.bun-card,.hiw-step,.stat-item,#hiwLineFill,#hiwResult,#guarInner').forEach(el=>io.observe(el));

['.prob-grid .prob-card','.ings-grid .ing-card','.rev-grid .rev-card','.bun-grid .bun-card'].forEach(sel=>{
  document.querySelectorAll(sel).forEach((el,i)=>{el.style.transitionDelay=`${i*80}ms`});
});
document.querySelectorAll('.hiw-step').forEach((el,i)=>el.style.transitionDelay=`${i*150}ms`);

document.querySelectorAll('.bun-card').forEach(card=>{
  card.addEventListener('click',()=>{
    document.querySelectorAll('.bun-card').forEach(c=>c.classList.remove('active'));
    card.classList.add('active');
  });
});

const otContent=document.querySelector('.ot-content.reveal');
if(otContent)otContent.style.transitionDelay='160ms';

const otImgWrap=document.querySelector('.ot-img-wrap.reveal');
if(otImgWrap){
  const otIO=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(!e.isIntersecting)return;
      const b1=document.getElementById('otBadge1');
      const b2=document.getElementById('otBadge2');
      if(b1)setTimeout(()=>{b1.style.cssText='opacity:1;transition:opacity .5s ease'},600);
      if(b2)setTimeout(()=>{b2.style.cssText='opacity:1;transition:opacity .5s ease'},900);
      otIO.unobserve(e.target);
    });
  },{threshold:.3});
  otIO.observe(otImgWrap);
}

const spNotifEl=document.getElementById('spNotif');
if(spNotifEl){
  const spData=[
    {avatar:'🐕',name:'Jessica M.',detail:'just ordered 2 Bottles from Austin, TX',time:'2 minutes ago'},
    {avatar:'🐩',name:'Rachel T.',detail:'just ordered 3 Bottles from Portland, OR',time:'4 minutes ago'},
    {avatar:'🦮',name:'Amanda K.',detail:'just ordered 1 Bottle from Chicago, IL',time:'6 minutes ago'},
    {avatar:'🐶',name:'Megan L.',detail:'just reordered — her 4th purchase!',time:'8 minutes ago'},
    {avatar:'🐕‍🦺',name:'Olivia S.',detail:'just ordered 2 Bottles from Denver, CO',time:'11 minutes ago'},
  ];
  let spIdx=0;
  function showSP(){
    const d=spData[spIdx%spData.length];
    document.getElementById('spAvatar').textContent=d.avatar;
    document.getElementById('spName').textContent=d.name;
    document.getElementById('spDetail').textContent=d.detail;
    document.getElementById('spTime').textContent=d.time;
    spNotifEl.classList.add('show');
    setTimeout(()=>spNotifEl.classList.remove('show'),4000);
    spIdx++;
  }
  setTimeout(()=>{showSP();setInterval(showSP,9000)},5000);
}

document.querySelectorAll('.fb-h,.fb-p,.fb-btn').forEach((el,i)=>{el.style.transitionDelay=`${i*130}ms`});

document.querySelectorAll('.prob-card').forEach(card=>{
  card.addEventListener('click',()=>{
    card.style.background='var(--orange-bg)';
    card.style.borderColor='var(--orange)';
    setTimeout(()=>{card.style.background='';card.style.borderColor=''},600);
  });
});
